import React from 'react';

interface Props {
  positionInPrec: string;
}

export const LinearGaugeCurrentCursor: React.FC<Props> = ({ positionInPrec }) => {
  return (
    <div style={{ left: `${positionInPrec}%` }} className={`absolute h-[3.75rem] z-20 flex flex-col`}>
      <div className="ml-[-0.7rem]  ">
        <img className=" grayscale  min-h-[1.5rem] min-w-[1.5rem] " src="/assets/icons/arrows/c-pointer.svg" alt="" />
      </div>
      <div className="h-full w-[0.1rem] bg-black "></div>
    </div>
  );
};
